import { useEffect, useState } from "react";
import {
  ObjectGroup,
} from "../../global/components/Modals/AdvancedConfiguration/MainSection";
import { MainSectionWrapper } from "../../global/components/Modals/AdvancedConfiguration/styles";

const SeparateTile = ({
  appName,
  data,
  advancedData,
  setAdvancedData,
  setIsStandardConfigTampered,
  parameterKeyName = "deploy-parameters",
  cvAppList,
  cvappid,
}) => {
  const [schemaData, setSchemaData] = useState({});
  const [isShowSeparateTile, setIsShowSeparateTile] = useState(false);

  useEffect(() => {
    setSchemaData({ ...data });
    if (
      data &&
      data?.scemaTemplateData &&
      typeof data?.scemaTemplateData === "object" &&
      Object.values(data?.scemaTemplateData).filter(
        (i) => i?.showSeparately === true
      )?.length > 0
    ) {
      setIsShowSeparateTile(true);
    }
  }, [data]);

  if (isShowSeparateTile) {
    return (
      <div className="vision-roi-box polygon-box--scroll150">
        <div style={{ marginTop: "15px" }}>
          <MainSectionWrapper>
            {schemaData?.scemaResourceData
              ?.filter((d) => schemaData?.scemaTemplateData[d?.key])
              ?.map((item) => {
                const schemaTemplateObject =
                  schemaData?.scemaTemplateData[item?.key];
                return (
                  <>
                    {(item?.elementType === "object" ||
                      schemaTemplateObject?.type === "object") &&
                      schemaTemplateObject?.showSeparately === true && (
                        <ObjectGroup
                          schemaTemplateObject={schemaTemplateObject}
                          cvAppName={appName}
                          keyName={item?.key}
                          parameterKeyName={parameterKeyName}
                          payload={advancedData}
                          setPayload={setAdvancedData}
                          setIsTampered={setIsStandardConfigTampered}
                          setErrorInFormInput={() => {}}
                          cvAppList={cvAppList}
                          cvappid={cvappid}
                        />
                      )}
                  </>
                );
              })}
          </MainSectionWrapper>
        </div>
      </div>
    );
  }
};

export default SeparateTile;
